import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import FeaturedPost from "./components/FeaturedPost";
import BlogGrid from "./components/BlogGrid";

export default function BlogPage() {
  return (
    <div className="min-h-screen flex flex-col bg-[#f9f9f9]">
      <Navbar />

      {/* Page Hero */}
      <section className="bg-black pt-32 pb-20 px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between gap-6">
            <div>
              <p
                className="text-white/30 text-xs tracking-[0.4em] uppercase mb-4"
                style={{ fontFamily: "'Barlow', sans-serif" }}
              >
                The Philadelphia Sandwich Co.
              </p>
              <h1
                className="text-white text-6xl md:text-8xl font-black uppercase leading-none"
                style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
              >
                From the<br />Counter
              </h1>
            </div>
            <p
              className="text-white/40 text-sm leading-relaxed max-w-xs hidden md:block pb-2"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              Stories about sandwiches, sourcing, craft, and the culture of Philadelphia food.
            </p>
          </div>
        </div>
      </section>

      {/* Thin color bar */}
      <div className="h-1 bg-white/10" />

      <main className="flex-1 py-16 md:py-20 px-6 md:px-10">
        <div className="max-w-7xl mx-auto space-y-16">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-[11px] tracking-[0.15em] uppercase text-black/30" style={{ fontFamily: "'Barlow', sans-serif" }}>
            <Link to="/" className="hover:text-black transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center" />
            <span className="text-black">Blog</span>
          </nav>

          {/* Featured */}
          <div>
            <p
              className="text-black/30 text-[10px] tracking-[0.35em] uppercase mb-5"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              Latest Story
            </p>
            <FeaturedPost />
          </div>

          {/* Divider */}
          <div className="h-px bg-black/10" />

          {/* All Posts Grid */}
          <div>
            <p
              className="text-black/30 text-[10px] tracking-[0.35em] uppercase mb-8"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              More Stories
            </p>
            <BlogGrid />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
